export default __webpack_public_path__ + "static/media/airdockz-cbb-banner-2.4e226411.jpg";